<template lang="pug">
  #app
    header
      .header-contents
        img(src="/common/logo.svg" alt="Wealth Wing")
    .main
      router-view
</template>
<script>
import '@/assets/style/destyle.css'
import '@/assets/style/app.sass'

import {Vue, Component} from 'vue-property-decorator'

@Component
export default class AppVue extends Vue {}

</script>
<style lang="sass">
@import "./assets/style/common"
#app
  position: relative
  header
    z-index: 10
    position: fixed
    height: 4rem
    background-color: white
    border-bottom: solid 2px $color-gold
    width: 100%
    display: flex
    justify-content: center
    .header-contents
      width: 100%
      padding: 0 1rem
      max-width: 1024px
      display: flex
      align-items: center
    @include is-size-mobile
      height: 3.2rem
  .main
    padding-top: 4rem
    margin: 0 auto
    max-width: 1024px
    @include is-size-mobile
      padding-top: 3.2rem
</style>
